/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../navigation.ts"/>

namespace Dealerware {

    export namespace Navigation {
        "use strict";

        export interface IDealerwareSideNavDelegate {

            // properties
            // -------------------------------------
            navigationId : string;

            // methods
            // -------------------------------------
            toggle()        : void;
            close()         : void;
            open()          : void;
            isOpen()        : boolean;
            isLockedOpen()  : boolean;

        }

        export interface IDealerwareSideNavLeftDelegate extends IDealerwareSideNavDelegate {

            // properties
            // -------------------------------------

            // methods
            // -------------------------------------

        }

        export interface IDealerwareSideNavController {

            // properties
            // ------------------------------------------
            navigationDelegate : IDealerwareSideNavDelegate;

            // methods
            // ------------------------------------------

        }

        export interface IDealerwareSideNavLeftController extends IDealerwareSideNavController {
            // properties
            // ------------------------------------------
            showLocationChooser : boolean;
        }

        export class DealerwareSideNavDelegate implements IDealerwareSideNavDelegate {

            // properties
            // --------------------------------------------
            public static $inject: string[] = ['$mdSidenav','$mdMedia'];

            public navigationId : string;

            // constructor
            // --------------------------------------------
            constructor(public $mdSidenav : any, public $mdMedia : any) {

            }

            // methods
            // --------------------------------------------
            public toggle()        : void {
                var _self = this;
                this.$mdSidenav(this.navigationId).toggle().then(function () {
                });
            }

            public close()         : void {
                var _self = this;
                this.$mdSidenav(this.navigationId).close().then(function () {
                });
            }

            public open()          : void {
                var _self = this;
                this.$mdSidenav(this.navigationId).open().then(function () {
                });
            }

            public isOpen()        : boolean {
                return this.$mdSidenav(this.navigationId).isOpen();
            }

            public isLockedOpen()  : boolean {
                return this.$mdSidenav(this.navigationId).isLockedOpen();
            }

            public toggleCollapsed()         : void {
                var _self = this;
                this.$mdSidenav(this.navigationId).close().then(function () {
                });
            }
        }

        export class DealerwareSideNavLeftDelegate extends DealerwareSideNavDelegate implements IDealerwareSideNavLeftDelegate {

            // properties
            // --------------------------------------------
            public static $inject: string[] = ['$mdSidenav','$mdMedia'];

            // constructor
            // --------------------------------------------
            constructor($mdSidenav : any,$mdMedia : any) {
                super($mdSidenav,$mdMedia);
                this.navigationId = 'left-side-nav';
            }

            // methods
            // --------------------------------------------

        }

        export class DealerwareSideNavController implements IDealerwareSideNavController {

            // properties
            // ------------------------------------------
            public static $inject : string[] = ['CurrentUser','$dealerwareSideNavDelegate'];

            // constructor
            // ------------------------------------------
            constructor(public CurrentUser : any,public navigationDelegate : IDealerwareSideNavDelegate) {

            }

            // methods
            // ------------------------------------------

        }

        export class DealerwareSideNavLeftController extends DealerwareSideNavController implements IDealerwareSideNavLeftController {

            // properties
            // ------------------------------------------
            public showLocationChooser : boolean;

            public sections : any;
            public isOpen : any;
            public menu : any;
            public status : any;

            public static $inject : string[] = [
                'CurrentUser',
                '$mobilityCompanyAuthentication',
                '$dealerwareSideNavLeftDelegate',
                'LocationCollection',
                '$scope',
                '$state',
                '$timeout',
                '$dealerwareSideNavLeftItems',
                '$rootScope'
            ];

            // constructor
            // ------------------------------------------
            constructor(
                public CurrentUser: any,
                public $mobilityCompanyAuthentication: any,
                delegate: IDealerwareSideNavDelegate,
                public locationCollection: any,
                public $scope: any,
                public $state: any,
                public $timeout: any,
                public $dealerwareSideNavLeftItems: any,
                public $rootScope: any
            ) {
                super(CurrentUser,delegate);
                var that = this;

                this.sections = [];
                angular.forEach(this.$dealerwareSideNavLeftItems.getSections(this.CurrentUser.user),
                    (section: any) => {
                        if (section.id === 'select-location') {
                            section.events.show = () => {
                                return this.showLocationChooser;
                            }
                        }
                        this.sections.push(angular.copy(section));
                    }
                );

                // Ensure user is completely authenticated before initializing the menu
                this.$scope.$watchGroup([
                    ()=> {
                        var location = this.$mobilityCompanyAuthentication.location;
                        return location ? location.id : undefined;
                    }
                ], (newValues: any) => {
                    var locationId = newValues[0];

                    if (locationId) {
                        this.CurrentUser.loadManagedCompanies().then(
                            (companies: any) => {
                                if (companies.data.length > 1) {
                                    this.showLocationChooser = true;
                                } else {
                                    this.locationCollection.activeLocations({ promise: true }).then(
                                        (locations: any) => {
                                            this.showLocationChooser = locations.data.length > 1;
                                        }
                                    );
                                }

                                // Initialization of this watcher sets left nav menu items initially.
                                //
                                this.$scope.$watch(() => {
                                    return this.CurrentUser.user && this.CurrentUser.user.data && this.CurrentUser.user.data.roles_mapped;
                                }, () => {

                                    // Reconstitute the sections entirely, both the list and each individually,
                                    // in order to get the menu.ts menu items to re-compile, reflecting any role
                                    // changes.
                                    //
                                    this.sections = [ ];
                                    angular.forEach(this.$dealerwareSideNavLeftItems.getSections(this.CurrentUser.user),
                                        (section: any) => {
                                            if (section.id === 'select-location') {
                                                section.events.show = () => {
                                                    return this.showLocationChooser;
                                                }
                                            }
                                            this.sections.push(angular.copy(section));
                                        }
                                    );
                                });
                            }
                        );
                    }
                });

                this.status = {
                    isFirstOpen: true,
                    isFirstDisabled: false
                };

            }
        }

        export class DealerwareSideNavLeftDirective implements ng.IDirective {

            public restrict         : string    =   'E';
            public controller       : any       =   '$dealerwareSideNavLeftController';
            public controllerAs     : string    =   'leftNavController';
            public bindToController : boolean   =   true;
            public replace          : boolean   =   false;
            public scope            : Object    =   {};
            public transclude       : boolean   =   false;
            public require          : string[]  =   [];
            public templateUrl      : string    =   '/navigation/side_nav/side_nav_left.html';
            public static $inject   : string[]  =   [];

            constructor() {

            }

            public link : ng.IDirectiveLinkFn = (
                scope   :   any,
                element :   ng.IAugmentedJQuery,
                attrs   :   ng.IAttributes
            ) => {

            }

        }

        getDealerwareNavigationModule().service('$dealerwareSideNavDelegate',DealerwareSideNavDelegate);
        getDealerwareNavigationModule().service('$dealerwareSideNavLeftDelegate',DealerwareSideNavLeftDelegate);
        getDealerwareNavigationModule().controller('$dealerwareSideNavLeftController',DealerwareSideNavLeftController);
        getDealerwareNavigationModule().directive("dealerwareSideNavigationLeft",() => new DealerwareSideNavLeftDirective());



        export class DealerwareSideNavLeftItems extends DealerwareSideNavLeftDelegate {

            public static $inject: string[] = ['CurrentUser', '$mdSidenav', '$mdMedia'];

            private sections     : any[];
            private currentUser  : any;

            constructor(
                public CurrentUser  : any,
                public $mdSidenav   : any,
                public $mdMedia     : any
            ) {

                super ($mdSidenav, $mdMedia);

                var that = this;

                this.currentUser = CurrentUser;

                var closeNav = ( ) => {
                    that.close();
                };

                this.sections = [

                    {
                        name    : 'Dashboard',
                        id      : 'dashboard',
                        type    : 'link',
                        state   : 'root.private.application.dashboard',
                        events  : {
                            click: closeNav
                        }
                    },

                    {
                        name    : 'Customers',
                        id      : 'customers',
                        type    : 'link',
                        state   : 'shortcuts.customersDashboard',
                        events  : {
                            click: closeNav
                        }
                    },

                    {
                        name    : 'Contracts',
                        id      : 'contracts',
                        type    : 'link',
                        state   : 'shortcuts.contractsDashboard',
                        events  : {
                            click: closeNav
                        }
                    },

                    {
                        name    : 'Vehicles',
                        id      : 'vehicles',
                        type    : 'link',
                        state   : 'shortcuts.vehiclesDashboard',
                        events  : {
                            click: closeNav
                        }
                    },

                    {
                        name    : 'Employees',
                        id      : 'employees',
                        type    : 'link',
                        state   : 'shortcuts.employeesDashboard',
                        events  : {
                            click: closeNav,
                            show: ( ) => {
                                return that.currentUser && that.currentUser.hasRole('user_manager');
                            }
                        }
                    },

                    {
                        name    : 'Select Location',
                        id      : 'select-location',
                        type    : 'link',
                        state   : 'shortcuts.chooseLocation',
                        events  : {
                            click: closeNav
                        }
                    },
                    {
                        name    : 'Settings',
                        id      : 'settings',
                        type    : 'toggle',
                        events  : {
                            show: ( ) => {
                                return that.currentUser && that.currentUser.hasRole('admin');
                            }
                        },
                        pages   : [
                            {
                                name    : 'Driver Agreement',
                                id      : 'customer-agreement',
                                type    : 'link',
                                state   : 'shortcuts.settingsLoanerAgreement',
                                events  : {
                                    click: closeNav,
                                    show: ( ) => {
                                        var location = that.CurrentUser.getLocation();
                                        return location && location.settings ? ! location.settings.pdp : false;
                                    }
                                }
                            },
                            {
                                name    : 'Driver Agreement Terms',
                                id      : 'customer-agreement-summary',
                                type    : 'link',
                                state   : 'shortcuts.settingsLoanerAgreementSummary',
                                events  : {
                                    click: closeNav
                                }
                            },
                            {
                                name    : 'Fleet Upload',
                                id      : 'fleet-upload',
                                type    : 'link',
                                state   : 'shortcuts.settingsFleetUpload',
                                events  : {
                                    click: closeNav
                                }
                            },
                            {
                                name    : 'Customer Expenses',
                                id      : 'expenses',
                                type    : 'link',
                                state   : 'shortcuts.settingsExpenses',
                                events  : {
                                    click: closeNav
                                }
                            },
                            {
                                name    : 'Location',
                                id      : 'locations',
                                type    : 'link',
                                state   : 'shortcuts.settingsLocations',
                                events  : {
                                    click: closeNav,
                                    show: ( ) => {
                                        return that.currentUser && that.currentUser.hasRole('admin');
                                    }
                                }
                            },
                            {
                                name    : 'Webhooks',
                                id      : 'webnooks',
                                type    : 'link',
                                state   : 'shortcuts.settingsWebhooks',
                                events  : {
                                    click: closeNav,
                                    show: ( ) => {
                                        return that.currentUser && that.currentUser.hasRole('admin');
                                    }
                                }
                            }
                        ]
                    },

                    {
                        name    : 'Reports',
                        id      : 'reports',
                        type    : 'toggle',
                        events  : {
                            show: ( ) => {
                                return that.currentUser && that.currentUser.hasRole('view_reports');
                            }
                        },
                        pages   : [
                            {
                                name    : 'Vehicle Inventory',
                                id      : 'reports-vehicle-inventory',
                                type    : 'link',
                                state   : 'shortcuts.reportsInventory',
                                events  : {
                                    click: closeNav
                                }
                            },
                            {
                                name    : 'Vehicle Utilization',
                                id      : 'reports-vehicle-utilization',
                                type    : 'link',
                                state   : 'shortcuts.reportsUtilization',
                                events  : {
                                    click: closeNav
                                }
                            },
                            {
                                name    : 'Contracts',
                                id      : 'reports-contracts',
                                type    : 'link',
                                state   : 'shortcuts.reportsContracts',
                                events  : {
                                    click: closeNav
                                }
                            },
                            {
                                name    : 'Transactions',
                                id      : 'reports-transactions',
                                type    : 'link',
                                state   : 'shortcuts.reportsTransactions',
                                events  : {
                                    click: closeNav
                                }
                            },
                            {
                                name    : 'Tolls',
                                id      : 'reports-tolls',
                                type    : 'link',
                                state   : 'shortcuts.reportsTolls',
                                events  : {
                                    click: closeNav
                                }
                            }
                        ]
                    },

                    {
                        name    : 'Training & Support',
                        id      : 'training-and-support',
                        type    : 'toggle',
                        pages   : [
                            {
                                name    : 'Training',
                                id      : 'training',
                                type    : 'link',
                                state   : 'shortcuts.dealerwareAcademy',
                                stateArgs: () => (that.CurrentUser && that.CurrentUser.user) ? {
                                    firstName: that.CurrentUser.user.data.user_profile_attributes.first_name,
                                    lastName: that.CurrentUser.user.data.user_profile_attributes.last_name,
                                    email: that.CurrentUser.user.data.email
                                } : {
                                    firstName: '',
                                    lastName: '',
                                    email: ''
                                },
                                events  : {
                                    click: closeNav
                                }
                            },
                            {
                                name    : 'F.A.Q.',
                                id      : 'faq',
                                type    : 'link',
                                state   : 'shortcuts.dealerwareHelp',
                                events  : {
                                    click: closeNav
                                }
                            },
                            {
                                name    : 'Contact Us',
                                id      : 'contact-us',
                                type    : 'link',
                                state   : 'shortcuts.dealerwareContactUs',
                                events  : {
                                    click: closeNav
                                }
                            }
                        ]
                    },

                    {
                        name    : 'Place Order <i class="fa fa-external-link"></i>',
                        id      : 'place-order',
                        type    : 'link',
                        state   : 'shortcuts.dealerwarePlaceOrder',
                        stateArgs: () => (that.CurrentUser && that.CurrentUser.user && that.CurrentUser.getLocation) ? {
                            firstName: that.CurrentUser.user.data.user_profile_attributes.first_name,
                            lastName: that.CurrentUser.user.data.user_profile_attributes.last_name,
                            email: that.CurrentUser.user.data.email,
                            dealershipName: that.CurrentUser.getLocation() ? that.CurrentUser.getLocation().name : '',
                            dealershipId: that.CurrentUser.getLocation() ? that.CurrentUser.getLocation().code : ''
                        } : {
                            firstName: '',
                            lastName: '',
                            email: '',
                            dealershipName: '',
                            dealershipId: ''
                        },
                        events  : {
                            click: closeNav
                        }
                    },

                    {
                        name    : 'About Dealerware',
                        type    : 'modal',
                        modal   : {
                            controller: 'AboutDealerwareController',
                            controllerAs: 'ctrl',
                            templateUrl: '/content/about/about_modal.html',
                            multiple: true,
                            clickOutsideToClose: true
                        },
                        events  : {
                            click: closeNav
                        }
                    },

                    {
                        name    : 'Log Out',
                        type    : 'link',
                        state   : 'shortcuts.logout'
                    }
                ];
            }

            public getSections ( user : any ) : any {
                this.currentUser = user;
                return this.sections;
            }

            public launchTraining() : void {
                window.open(
                    "http://dealerware.schoolkeep.com/?first_name="
                        + this.CurrentUser.user.data.user_profile_attributes.first_name
                        + "&last_name=" + this.CurrentUser.user.data.user_profile_attributes.last_name
                        + "&email=" + this.CurrentUser.user.data.email
                );
                this.close()
            }
        }

        getDealerwareNavigationModule().factory(
            '$dealerwareSideNavLeftItems', (
                CurrentUser: any, $mdSidenav: any, $mdMedia: any
            ) => new DealerwareSideNavLeftItems(CurrentUser, $mdSidenav, $mdMedia)
        );
    }

}
